<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn class="mr-4" color="primary" dark @click.stop="dialog = true">
            Add Availability
          </v-btn>
          <v-btn outlined class="mr-4" @click="setToday">
            Today
          </v-btn>
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-menu bottom right >
            <template v-slot:activator="{ on }">
              <v-btn outlined v-on="on" class="mr-4">
                <span>{{selectedAppointment }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list >
              <v-list-item  v-for="ap in allAppointments" :key="ap" :items="allAppointments" @click="changeName(ap)">
                <v-list-item-title>{{ap}}</v-list-item-title>
              </v-list-item>
             
            </v-list>
          </v-menu>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn outlined v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 Days</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>

      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-container>
            <v-form @submit.prevent="addEvent">
               <v-text-field
                v-model="firstName"
                type="text"
                label="Nome"
              ></v-text-field>
                <v-text-field
                v-model="lastName"
                type="text"
                label="Cognome"
              ></v-text-field>
            <v-select
                  :items="appointments"
                  v-model="appointmentWith"
                  label="Consulente con"
                ></v-select>
                <v-select
                  :items="items"
                  v-model="appointmentTime"
                  label="Orario Appuntamento"
                  multiple
                  filled
                  chips
                ></v-select>
              <v-text-field
                v-model="appointmentDate"
                type="date"
                label="Data di appuntamento"
              ></v-text-field>
              <v-btn
                type="submit"
                color="primary"
                class="mr-4"
                @click.stop="dialog = false"
              >
                create event
              </v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDate" max-width="500">
        <v-card>
          <v-container>
            <v-form @submit.prevent="addEvent">
               <v-text-field
                v-model="firstName"
                type="text"
                label="Nome"
              ></v-text-field>
                <v-text-field
                v-model="lastName"
                type="text"
                label="Cognome"
              ></v-text-field>
             
            <v-select
                  :items="appointments"
                  v-model="appointmentWith"
                  label="Consulente con"
                ></v-select>
                <v-select
                  :items="items"
                  v-model="appointmentTime"
                  label="Orario Appuntamento"
                  multiple
                  filled
                  chips
                ></v-select>
              <v-text-field
                v-model="appointmentDate"
                type="date"
                label="Data di appuntamento"
              ></v-text-field>
              <v-btn
                type="submit"
                color="primary"
                class="mr-4"
                @click.stop="dialog = false"
              >
                create event
              </v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>

      <v-sheet height="800">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :event-margin-bottom="3"
          :now="today"
          :type="type"
          :event-overlap-mode="mode"
          :event-overlap-threshold="60"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="setDialogDate"
          @change="updateRange"
        >
          <template v-slot:event="{ event }">
          <div class="v-event-draggable">
            <strong style="font-size:14px;">{{ formatEventTime(event.start) }} -{{ event.name }}</strong><br>
          </div>
        </template>
        </v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" :width="350" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn @click="deleteEvent(selectedEvent.id)" icon>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-card-text>
              <form v-if="currentlyEditing !== selectedEvent.id">
                <p>
                  Nome: {{ selectedEvent.firstName }}
                  {{ selectedEvent.lastName }}
                </p>
                <p>Email: <a :href="'mailto:' + selectedEvent.email"> {{ selectedEvent.email }}</a></p>
                <p v-if="selectedEvent.phone">
                  Telefono: {{ selectedEvent.phone }}
                </p>
                <p>Orario Appuntamento: {{ selectedEvent.appointmentTime }}</p>
                <p v-if="selectedEvent.Prodotto">Prodotto: {{ selectedEvent.Prodotto }}</p>
                <p  v-if="selectedEvent.note">
                  Note:
                  <textarea-autosize
                    v-model="selectedEvent.note"
                    type="text"
                    style="width: 100%"
                    :min-height="100"
                    placeholder="add note"
                  >
                  </textarea-autosize>
                </p>
                
              </form>
              <form v-else>
                <v-select
                  :items="appointments"
                  v-model="selectedEvent.appointmentWith"
                  label="Consulente con"
                ></v-select>
                <v-select
                  :items="items"
                  v-model="selectedEvent.appointmentTime"
                  label="Orario Appuntamento"
                ></v-select>
                <textarea-autosize
                  v-model="selectedEvent.note"
                  type="text"
                  style="width: 100%"
                  :min-height="100"
                  placeholder="add note"
                >
                </textarea-autosize>
              </form>
            </v-card-text>

            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                close
              </v-btn>
              <v-btn
                v-if="currentlyEditing !== selectedEvent.id"
                text
                @click.prevent="editEvent(selectedEvent)"
              >
                edit
              </v-btn>
              <v-btn
                text
                v-else
                type="submit"
                @click.prevent="updateEvent(selectedEvent)"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { db } from "@/main";
import _ from "lodash";
import * as dayjs from "dayjs";
export default {
  data: () => ({
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedAppointment:'Nessuna preferenza',
    appointments: ['Antonio','Giacomo','Luigi'],
    appointmentTime: null,
    appointmentWith: null,
    appointmentDate: null,
    firstName: null,
    lastName: null,
    name: null,
    details: null,
    start: null,
    end: null,
    color: "#1976D2", // default event color
    currentlyEditing: null,
    selectedEvent: {},
    items: [
      "09:00",
      "09:15",
      "09:30",
      "09:45",
      "10:00",
      "10:15",
      "10:30",
      "10:45",
      "11:00",
      "11:15",
      "11:30",
      "11:45",
      "12:00",
      "12:15",
      "12:30",
      "15:00",
      "15:15",
      "15:30",
      "15:45",
      "16:00",
      "16:15",
      "16:30",
      "16:45",
      "17:00",
      "17:15",
      "17:30",
      "17:45",
      "18:00",
      "18:15",
      "18:30",
      "18:45",
      "19:00",
    ],
    selectedElement: null,
    selectedOpen: false,
    events: [],
    events2: [],
    dialog: false,
    dialogDate: false,
     types: ['month', 'week', 'day', '4day'],
      mode: 'stack',
      modes: ['stack', 'column'],
      value: '',
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'black','brown', 'grey darken-1'],
  }),
  mounted() {
    this.getEvents();
  },
  computed: {
    allAppointments(){
      return ['Nessuna preferenza',...this.appointments];
    },
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }
      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? "" : endMonth;
      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? "" : endYear;
      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);
      switch (this.type) {
        case "month":
          return `${startMonth} ${startYear}`;
        case "week":
        case "4day":
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case "day":
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long",
      });
    },
  },
  methods: {
    async getEvents() {
      let snapshot = await db.collection("Calendario").get();
      const events = [];
      snapshot.forEach((doc) => {
        let appData = doc.data();
        let appName = `Consulente con ${appData["appointmentWith"]}`;
        let appTime = `${appData["appointmentTime"]}`;
        appTime = appTime.split(",");
        appTime = _.sortBy(appTime);
        console.log(appData["appointmentDate"]);
        console.log(appTime);
        let newDate = dayjs(appData["appointmentDate"]).format("YYYY-MM-DD");
        let appDate = new Date(`${newDate} ${appTime[0]}`);
        appData.start =  appDate;
        console.log(appData.start);
        let appEndDate =  new Date(`${newDate} ${appTime[appTime.length - 1]}`);
        if(appTime.length > 1){
          appEndDate = (new Date(appEndDate)).setMinutes(90);
        }
        console.log(appEndDate);

        appData.end = appEndDate;
        appData.name = appName;
        appData.id = doc.id;
        appData.timed = true;
        appData.color =
          this.colors[this.rnd(0, this.colors.length - 1)];
        events.push(appData);
      });
      this.events = events;
      this.events2 = events;
    },
      formatEventTime(date) {
        return new Date(date).toLocaleTimeString('en-US', {
          hour: "2-digit", 
          minute: "2-digit", 
          hour12: false
        })
      },
    changeName(name){
      this.selectedAppointment = name;
      if(name === 'Nessuna preferenza') {
        this.events = this.events2;

      }
      else{ 
         let filterEvent = this.events2.filter( ({appointmentWith}) => appointmentWith == this.selectedAppointment);
      console.log(filterEvent);
      return this.events = filterEvent;
      }
    },
    setDialogDate({ date }) {
      this.dialogDate = true;
      this.focus = date;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    async addEvent() {
      if (this.appointmentWith && this.appointmentDate && this.appointmentTime) {
        await db.collection("Calendario").add({
          appointmentWith: this.appointmentWith,
          firstName: this.firstName,
          lastName: this.lastName,
          appointmentTime: this.appointmentTime,
          appointmentDate: dayjs(this.appointmentDate).format("ddd DD MMM, YYYY"),
          email: 'filatori@gmail.com'
        });
        this.getEvents();
        (this.appointmentWith = ""),
        (this.firstName = ""),
        (this.lastName = ""),
          (this.appointmentTime = ""),
          (this.appointmentDate = "");
      } else {
        alert("You must enter event appointmentWith, start, and end appointmentTime");
      }
    },
    editEvent(ev) {
      this.currentlyEditing = ev.id;
    },
    async updateEvent(ev) {
        console.log(ev);
        console.log(this.currentlyEditing);
      await db
        .collection("Calendario")
        .doc(this.currentlyEditing)
        .update({
          appointmentWith: ev.appointmentWith,
          appointmentTime: ev.appointmentTime,
          note: ev.note,
        });
      (this.selectedOpen = false), (this.currentlyEditing = null);
     
    //  this.events.filter( )

    },
    async deleteEvent(ev) {
      await db
        .collection("Calendario")
        .doc(ev)
        .delete();
      (this.selectedOpen = false), this.getEvents();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      this.start = start;
      this.end = end;
    },
    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    },
          rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
  },
};
</script>
